import CartConn from '@/connection/cart.js'
import { EventBus } from '@/behaviours/event-bus'
import _ from 'lodash'

export default {
  methods: {
    async addToCart (product, productViewId, comments) {
      console.log(product)
      if (!this.$store.state.cartLocked) {
        this.$store.state.cartLocked = true
        let translatedOptions = this.translateFoodOptions(product)
        console.log('translated options', translatedOptions)
        await CartConn.addToCart(product.id, productViewId, comments, translatedOptions)
        this.$store.state.cartLocked = false
      } else {
        console.log('waiting cart')
      }
      this.$forceUpdate()
    },

    translateFoodOptions (product) {
      if (!product.options || !product.options.length){
        return null
      } else {
        let options = []
        // ofr each option of a product
        product.options.forEach((o) => {
          let option = {
            id: o.id,
            label: o.label,
            choices: []
          }
          // for each choice of a option
          o.choices.forEach((c) => {
            if (c.selected_qtd) {
              option.choices.push({id: c.id, quantity: c.selected_qtd, label: c.label, price: (c.price || 0)})
            }
          })
          // if one or more choice is checkec add this option to product options
          if (option.choices.length){
            options.push(option)
          }
        })
        // if at least one option is selected in the options array
        // return the options to be inserted in the product cart
        if (options.length) {
          return options
        } else {
          return null
        }
      }
    },

    getQtd (productId, productViewId, productCartId) {
      return CartConn.getQtd(productId, productViewId, productCartId)
    },

    async plusQtd(productId, productViewId, productCartId) {
      console.log(productCartId)
      if (!this.$store.state.cartLocked) {
        this.$store.state.cartLocked = true
        let did = await CartConn.plusQtd(productId, productViewId, productCartId)
        if (did[0] === false) {
          EventBus.$emit('showAlert', 'info', did[1])
        }
        this.$store.state.cartLocked = false
      } else {
        console.log('waiting cart')
      }
    },

    async minusQtd (productId, productViewId, productCartId) {
      if (!this.$store.state.cartLocked) {
        this.$store.state.cartLocked = true
        await CartConn.minusQtd(productId, productViewId, productCartId)
        this.$forceUpdate()
        this.$store.state.cartLocked = false
      } else {
        console.log('waiting cart')
      }
    },

    clearCart () {
      this.$store.state.cart = {
        products: [],
        total: 0,
        totalDiscount: 0,
        subTotal: 0,
        deliveryTax: 0
      }
      this.$store.state.cupomCode = null
      this.$store.state.cupomObject = null
      this.$store.state.cartLocked = false
    },

    getItensTotal () {
      if (this.$store.state.cart && this.$store.state.cart.products.length) {
        let products = _.clone(this.$store.state.cart.products)
        return products.map(p => p.qtd).reduce((a, v) => a + v)
      } else {
        return 0
      }
    },

    isOnCart (productId, productViewId) {
      if (this.$store.state.cart && this.$store.state.cart.products.length) {
        let products = _.clone(this.$store.state.cart.products)
        return products.filter(p => p.id === productId && p.productViewId === productViewId).length > 0
      }
      return false
    },

    async updateCartCupom () {
      let cart = this.$store.state.cart
      return await CartConn.reCalculateCart(cart)
    },

    getWastelessPrice (product) {
      return CartConn.getWastelessRightPrice (product)
    } 

  }
}